import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  useLoaderData,
  useRouteError,
  useNavigate,
  redirect,
} from "react-router-dom";
import ResourceDisplay from "../../../components/resource-display";
import NewsSummaryCard from "../../../components/news-summary-card/index";

import { default as Markdown } from "react-remarkable";
import GenericErrorDisplay from "../../generic-error";
import { AxiosError } from "axios";

import React, { useEffect } from "react";
import { IMAGE_HOST } from "../../../api/config";
import ResourceService from "../../../service/resource";
import NewsService from "../../../service/news";

const paramName = "name";
export const path = ":" + paramName + "/";

const resourceKeys = {
  backgroundImage: "image-paper-white",
  relatedTitle: "news-detail-related-title",
};

export async function loader({ params }) {
  const resources = new ResourceService().read.byIds(
    Object.values(resourceKeys),
  );

  try {
    const name = params[paramName];
    const data = new NewsService().read.detail(name);
    return [await data, await resources];
  } catch (error) {
    if (
      error instanceof AxiosError &&
      error.response &&
      error.response.status === 404
    ) {
      redirect("/not-found");
    }
    throw error;
  }
}

export function Component() {
  const [data, resources] = useLoaderData();

  return (
    <div id="pages-news-detail">
      <div className="header">
        <div className="background-image">
          <img src={IMAGE_HOST + data.back_img} alt={data.name} />
        </div>

        <div className="container content-container">
          <div className="text">
            <div className="stretcher" />
            <h3 className="title">{data.title}</h3>
            <div className="stretcher" />
            <div className="hashtag">
              {data.hashtags.map((elem) => (
                <div key={elem.id}>#{elem}</div>
              ))}
            </div>
            <div className="date">
              <span className="bold">
                {data.date.toLocaleDateString("ro-RO", { dateStyle: "long" })}
              </span>
            </div>
            <div className="icons">
              {(data.facebook ?? "") !== "" && (
                <a href={data.facebook}>
                  <FontAwesomeIcon size="xl" icon={faFacebook} />
                </a>
              )}
              {(data.instagram ?? "") !== "" && (
                <a href={data.instagram}>
                  <FontAwesomeIcon size="xl" icon={faInstagram} />
                </a>
              )}
            </div>
          </div>
          <div className="foreground-image-container">
            <img
              className="foreground-image"
              src={IMAGE_HOST + data.front_img}
              alt={data.name}
            />
          </div>
        </div>
      </div>
      <div
        className="body"
        style={
          resources[resourceKeys.backgroundImage]
            ? {
                backgroundImage:
                  "url(" +
                  IMAGE_HOST +
                  resources[resourceKeys.backgroundImage].value +
                  ")",
              }
            : {}
        }
      >
        <div className="maincontainer content-container">
          <div className="text">
            <Markdown source={data.content} />
          </div>
        </div>
        <ResourceDisplay
          resource={resources[resourceKeys.relatedTitle]}
          className="nearfooter"
          wrapper="h3"
        />
        <div className="news-container content-container">
          {data.related.map((elem) => (
            <NewsSummaryCard key={elem.id} newsSummary={elem}></NewsSummaryCard>
          ))}
        </div>
      </div>
    </div>
  );
}

Component.displayName = "page-noutate-detaliu";

export function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      error instanceof AxiosError &&
      error.response &&
      error.response.status === 404
    ) {
      navigate("/not-found", { replace: true });
    }
  }, [error, navigate]);

  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-noutate-detaliu-error";
